import { Card, CardContent, CardHeader, CardTitle } from "@shared/components/ui/card";
import { calculatePercentage } from "@shared/utils/helper";
import { CheckCircle, XCircle, UploadCloud } from "lucide-react";

export default function ImportStatistics({ stats }) {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 max-s">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Imports</CardTitle>
          <UploadCloud className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.total}</div>
          <p className="text-xs text-muted-foreground">Items processed</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Successful Imports
          </CardTitle>
          <CheckCircle className="h-4 w-4 text-green-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.successful}</div>
          <p className="text-xs text-muted-foreground">
            {calculatePercentage(stats.successful, stats.total)}% of total imports
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Failed Imports</CardTitle>
          <XCircle className="h-4 w-4 text-red-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.failed}</div>
          <p className="text-xs text-muted-foreground">
            {calculatePercentage(stats.failed, stats.total)}% of total imports
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
